import classNames from "classnames";
import React, { ComponentPropsWithRef, useRef } from "react";
import { mergeRefs } from "use-callback-ref";
import "./transparent-button.css";

interface TransparentButtonProps extends ComponentPropsWithRef<"button"> {
	/** Disable hover effect */
	noHover?: boolean;
	/** Ref to the button element */
	ref?: React.Ref<HTMLButtonElement>;
}

/** A standard button with a transparent background and no border */
export const TransparentButton = ({
	children,
	className,
	noHover,
	ref,
	...props
}: TransparentButtonProps) => {
	const innerRef = useRef<HTMLButtonElement>(null);

	return (
		<button
			type="button"
			ref={ref ? mergeRefs([ref, innerRef]) : innerRef}
			className={classNames([
				"transparent-button",
				className,
				{ "transparent-button--no-hover": noHover },
			])}
			{...props}
		>
			{children}
		</button>
	);
};

TransparentButton.displayName = "TransparentButton";
